import React from 'react';
import Hero from "../components/Hero";
import styles from "../styles/cookies.module.css";

export default function Cookies() {
    return (
        <main>
            <Hero subtitle="Política de Cookies " />
        <section className={styles.contenido}>
            <h2>INFORMACIÓN SOBRE COOKIES</h2>
            <p>
                Debido a la entrada en vigor de la referente modificación de la “Ley de Servicios de la Sociedad de la Información” (LSSICE) establecida por el Real Decreto 13/2012, es de obligación obtener el consentimiento expreso del usuario de todas las páginas web que usan cookies prescindibles, antes de que éste navegue por ellas.
            </p>

            <h2>¿QUÉ SON LAS COOKIES?</h2>
            <p>
                Las cookies y otras tecnologías similares tales como local shared objects, flash cookies o píxeles, son herramientas empleadas por los servidores Web para almacenar y recuperar información acerca de sus visitantes, así como para ofrecer un correcto funcionamiento del sitio.
            </p>
            <p>
                Mediante el uso de estos dispositivos se permite al servidor Web recordar algunos datos concernientes al usuario, como sus preferencias para la visualización de las páginas de ese servidor, nombre y contraseña, productos que más le interesan, etc.
            </p>

            <h2>COOKIES AFECTADAS POR LA NORMATIVA Y COOKIES EXCEPTUADAS</h2>
            <p>
                Según la directiva de la UE, las cookies que requieren el consentimiento informado por parte del usuario son las cookies de analítica y las de publicidad y afiliación, quedando exceptuadas las de carácter técnico y las necesarias para el funcionamiento del sitio web o la prestación de servicios expresamente solicitados por el usuario.
            </p>

            <h2>¿QUÉ TIPOS DE COOKIES EXISTEN?</h2>
            <ul>
                <li>Cookies analíticas: recogen información del uso que se realiza del sitio web.</li>
                <li>Cookies sociales: son aquellas necesarias para redes sociales externas.</li>
                <li>Cookies de afiliados: permiten hacer un seguimiento de las visitas procedentes de otras webs.</li>
                <li>Cookies de publicidad y comportamentales: recogen información sobre preferencias y elecciones personales del usuario.</li>
                <li>Cookies técnicas y funcionales: necesarias para el uso del sitio web.</li>
            </ul>

            <h2>COOKIES QUE SE UTILIZAN EN ESTE SITIO WEB</h2>
            <ul>
                <li>PHPSESSID: técnica y estrictamente necesaria. Se elimina al cerrar el navegador.</li>
                <li>_lang: técnica y estrictamente necesaria. Se elimina al cerrar el navegador.</li>
                <li>ac_cookies: técnica y estrictamente necesaria. Caduca en 1 año.</li>
                <li>_ga: Google Analytics. Caduca en 2 años.</li>
                <li>_gat: Google Analytics. Caduca a los 10 minutos.</li>
                <li>_gid: Google Analytics. Caduca en 24 horas.</li>
            </ul>

            <h2>REVOCACIÓN DEL CONSENTIMIENTO / CÓMO ELIMINAR LAS COOKIES</h2>
            <p>Chrome: <a href="http://support.google.com/chrome/answer/95647?hl=es" target="_blank">Más información</a></p>
            <p>Internet Explorer: <a href="https://support.microsoft.com/es-es/help/278835/how-to-delete-cookie-files-in-internet-explorer" target="_blank">Más información</a></p>
            <p>Firefox: <a href="https://www.mozilla.org/es-ES/privacy/websites/#cookies" target="_blank">Más información</a></p>
            <p>Safari: <a href="https://www.apple.com/legal/privacy/en-ww/cookies/" target="_blank">Más información</a></p>
            <p>Opera: <a href="https://help.opera.com/en/latest/security-and-privacy/#clearBrowsingData" target="_blank">Más información</a></p>
            <p>Otros navegadores: consulte la documentación del navegador que tenga instalado.</p>
            </section>
            </main>
    );
}
